namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonSumBillDtForm {
    }

    export class ReportRefundReasonSumBillDtForm extends Serenity.PrefixedContext {
        static formKey = 'RefundReasonReport.ReportRefundReasonSumBillDt';
    }
}
